<div class="callback project-backdrop" data-backdrop="vagues">
  <p class="callback__brand">mokah<span>+</span></p>

  <div class="callback__card" aria-live="polite">
    @if (state() === 'loading') {
      <img class="callback__mascot" [src]="mascot" alt="" width="112" height="112" aria-hidden="true" />
      <div class="callback__spinner" aria-hidden="true"></div>
      <h1 class="callback__title">Vérification de votre email…</h1>
      <p class="callback__sublabel">Un instant, nous confirmons votre adresse.</p>
    }

    @if (state() === 'naming') {
      <img class="callback__mascot" [src]="namingMascot" alt="" width="112" height="112" aria-hidden="true" />
      <p class="callback__eyebrow">Adresse confirmée</p>
      <h1 class="callback__title" id="naming-title">Comment s'appelle votre entreprise ?</h1>
      <p class="callback__sublabel">Ce nom identifie votre espace auprès de votre équipe. Vous pourrez le modifier plus tard.</p>

      <form class="callback__form" aria-labelledby="naming-title" (submit)="submitOrganisation($event)">
        <div class="form-group">
          <label for="cb-organisation" class="form-label">Nom de l'entreprise <span class="required">*</span></label>
          <div class="input-wrapper">
            <ng-icon name="iconoirBuilding" class="input-icon" size="18"></ng-icon>
            <input
              id="cb-organisation"
              name="organisation"
              type="text"
              class="form-input"
              autocomplete="organization"
              placeholder="Ex. : Les Cafés Martin"
              [formControl]="organisationCtrl"
              [attr.aria-invalid]="organisationError() ? 'true' : null"
              [attr.aria-describedby]="organisationError() ? 'cb-organisation-error' : null"
              (input)="organisationError.set(null)"
            >
          </div>
          @if (organisationError()) {
            <span class="error-message" id="cb-organisation-error" role="alert">{{ organisationError() }}</span>
          }
        </div>

        <app-btn
          class="callback__submit"
          [config]="{ type: 'filled', color: 'coffee', icon: 'iconoirArrowRight' }"
          (click)="submitOrganisation()"
        >
          Créer mon espace
        </app-btn>
      </form>
    }

    @if (state() === 'provisioning') {
      <img class="callback__mascot" [src]="mascot" alt="" width="112" height="112" aria-hidden="true" />
      <div class="callback__spinner" aria-hidden="true"></div>
      <h1 class="callback__title">Activation de votre compte…</h1>
      <p class="callback__sublabel">Nous préparons votre espace de travail, cela ne prend que quelques secondes.</p>
    }

    @if (state() === 'error') {
      <!-- Erreur : ton sobre, pas de mascotte -->
      <div class="callback__error-icon">
        <ng-icon name="iconoirWarningTriangle" size="28"></ng-icon>
      </div>
      <h1 class="callback__title">Activation impossible</h1>
      <p class="callback__error-message" role="alert">{{ errorMessage() }}</p>
      @if (canRetry()) {
        <button type="button" class="callback__back-link" (click)="retry()">Réessayer</button>
        <a href="/sign-in" class="callback__secondary-link">Retour à la connexion</a>
      } @else {
        <a href="/sign-in" class="callback__back-link">Retour à la connexion</a>
      }
    }
  </div>
</div>
